import { useCallback } from 'react';

export function usePriceWidgetHourGenerator() {
  const generateHourArray = useCallback(() => {
    return new Array(24).fill(0).map((_, idx) => +idx);
  }, []);

  const generateHourArrayWithoutTen = useCallback(() => {
    const hoursInADay = generateHourArray();
    const idxOfTen = 10;
    hoursInADay.splice(idxOfTen, 1);
    return hoursInADay;
  }, []);

  return {
    generateHourArray,
    generateHourArrayWithoutTen,
  };
}
